module.exports = __webpack_public_path__ + "static/media/productosoff.33720c74.svg";